module.exports = __webpack_public_path__ + "img/6.81ed072d.jpg";